/**
 * Converts a React CSSProperties-style font description
 * into a canvas-compatible font string for @chenglou/pretext.
 *
 * Example: { fontWeight: 300, fontSize: 48, fontFamily: "'Playfair Display', serif" }
 *       → "300 48px 'Playfair Display'"
 */
export function toFontSpec(style: {
  fontWeight?: number | string;
  fontSize?: number | string;
  fontFamily?: string;
  fontStyle?: string;
}): string {
  const parts: string[] = [];

  if (style.fontStyle) parts.push(style.fontStyle);
  if (style.fontWeight) parts.push(String(style.fontWeight));

  const size = typeof style.fontSize === "number" ? `${style.fontSize}px` : (style.fontSize || "16px");
  parts.push(size);

  // Strip fallback fonts — canvas only uses the first family
  const family = (style.fontFamily || "sans-serif").split(",")[0].trim();
  parts.push(family);

  return parts.join(" ");
}
